/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Link,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

export const DueDateComponent = ({
  workflows,
  setWorkflows,
  selectedTaskIndex,
  entityIdentifier,
}) => {
  const [changeDueDate, setChangeDueDate] = React.useState(false);

  React.useEffect(() => {
    setChangeDueDate(false);
  }, [entityIdentifier])

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);

  const { dueDateTime } = workflows[selectedTaskIndex];
  const { dueDateStatusChangeId } = workflows[selectedTaskIndex];
  const { dueDateTimeEndOfDay } = workflows[selectedTaskIndex];

  const handleDueDateChange = (index, days = 0, hours = 0, minutes = 0) => {
    const newValue = (86400000 * days) + (3600000 * hours) + (60000 * minutes);
    const updatedWorkflows = workflows;
    updatedWorkflows[index].dueDateTime = newValue < 0
      ? 0
      : newValue;
    updatedWorkflows[index].dueDateTimeEndOfDay = false;
    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
  };

  return (!changeDueDate
    ? (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 0.5,
        }}
      >
        {
          dueDateTime
            ? (
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: '14px',
                  mr: 1,
                }}
              >
                {
                  dueDateTimeEndOfDay
                    ? 'Complete by end of day'
                    : `Complete ${moment(new Date(new Date().getTime() + dueDateTime)).fromNow().replace('in ', '')} from start`
                }
              </Typography>
            )
            : <Box />
        }
        <Link
          component="button"
          variant="body2"
          color="secondary"
          underline="hover"
          onClick={() => {
            if (!dueDateTime) {
              const updatedWorkflows = workflows;
              updatedWorkflows[selectedTaskIndex].dueDateTimeEndOfDay = true;
              updatedWorkflows[selectedTaskIndex].dueDateTime = 1; // needs to be greater than 0
              setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
            }
            setChangeDueDate(true);
          }}
        >
          {dueDateTime
            ? 'Modify'
            : 'Track Task Completion Time'}
        </Link>
      </Box>
    )
    : (
      <Box>
        {
          !!dueDateTime && (
            <Box>
              <FormControl component="fieldset" variant="standard">
                <FormLabel
                  sx={{ margin: 0 }}
                >Complete Task By
                </FormLabel>
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    label="Days End"
                    sx={[{
                      m: 0,
                      mr: 0.5,
                      fontSize: '12px !important',
                      fontWeight: 400,
                      lineHeight: '14px !important',
                      color: '#9e9e9e',
                    }, dueDateTimeEndOfDay
                      ? { mb: 0 }
                      : { mb: 1 }]}
                    labelPlacement={dueDateTimeEndOfDay
                      ? 'start'
                      : 'top'}
                    control={(
                      <Checkbox
                        size="small"
                        sx={{
                          m: 0,
                          ml: 0.5,
                          fontSize: '12px !important',
                          p: 0,
                        }}
                        checked={!!dueDateTimeEndOfDay}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const updatedWorkflows = workflows;
                            updatedWorkflows[selectedTaskIndex].dueDateTimeEndOfDay = true;
                            updatedWorkflows[selectedTaskIndex].dueDateTime = 1; // needs to be greater than 0
                            setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                          } else {
                            handleDueDateChange(
                              selectedTaskIndex,
                              0,
                              2,
                              0,
                            );
                          }
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    )}
                  />
                  {
                    !dueDateTimeEndOfDay && (
                      <TextField
                        id="default-due-date-days-workflow"
                        label="Days"
                        sx={{
                          width: 60,
                          mr: 0.5,
                        }}
                        type="number"
                        margin="dense"
                        size="small"
                        value={Math.floor(dueDateTime / 8.64e7 || 0)}
                        onChange={(e) => {
                          handleDueDateChange(
                            selectedTaskIndex,
                            e.target.value,
                            Math.floor((dueDateTime % 8.64e7) / 3.6e6 || 0),
                            Math.round((dueDateTime % 3.6e6) / 6e4) || 0,
                          );
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )
                  }

                  {
                    !dueDateTimeEndOfDay && (
                      <TextField
                        id="default-due-date-hours-workflow"
                        label="Hours"
                        sx={{
                          width: 60,
                          mr: 0.5,
                        }}
                        type="number"
                        margin="dense"
                        size="small"
                        value={Math.floor((dueDateTime % 8.64e7) / 3.6e6 || 0)}
                        onChange={(e) => {
                          handleDueDateChange(
                            selectedTaskIndex,
                            Math.floor(dueDateTime / 8.64e7 || 0),
                            e.target.value,
                            Math.round((dueDateTime % 3.6e6) / 6e4) || 0,
                          );
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )
                  }

                  {
                    !dueDateTimeEndOfDay && (
                      <TextField
                        id="default-due-date-minutes-workflow"
                        label="Mins"
                        sx={{ width: 60 }}
                        type="number"
                        margin="dense"
                        size="small"
                        value={Math.round((dueDateTime % 3.6e6) / 6e4) || 0}
                        onChange={(e) => {
                          handleDueDateChange(
                            selectedTaskIndex,
                            Math.floor(dueDateTime / 8.64e7 || 0),
                            Math.floor((dueDateTime % 8.64e7) / 3.6e6 || 0),
                            e.target.value,
                          );
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )
                  }
                </FormGroup>
              </FormControl>
            </Box>
          )
        }
        {
          !!dueDateTime && (
            <Tooltip title="When selected, Questri will automatically complete this task once the tracked completion time expires on the task.">
              <FormControlLabel
                label="Auto-complete task after elapsed completion time"
                sx={[{
                  m: 0,
                  fontSize: '14px !important',
                  fontWeight: 400,
                  lineHeight: 1.2,
                  textWrap: 'wrap',
                }, dueDateTimeEndOfDay
                  ? { color: 'inherit' }
                  : { color: '#9e9e9e' }]}
                componentsProps={{
                  typography: {
                    fontSize: '14px !important',
                    lineHeight: 1.2,
                  },
                }}
                labelPlacement="end"
                control={(
                  <Switch
                    size="small"
                    checked={!!dueDateStatusChangeId}
                    onChange={(e) => {
                      const updatedWorkflows = workflows;
                      updatedWorkflows[selectedTaskIndex].dueDateStatusChangeId = e.target.checked
                        ? (selectedBarn && selectedBarn.barnMetadata.statusEndId) || 0
                        : 0;
                      setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                )}
              />
            </Tooltip>
          )
        }
        <Tooltip
          title={dueDateTime
            ? 'Remove tracking the the time to complete this task. No reminder or notifications will be sent.'
            : 'Specify the amount of time from the start of this task for when it should be completed.'}
        >
          <Link
            component="button"
            variant="body2"
            color="secondary"
            underline="hover"
            sx={{ mt: 1 }}
            onClick={() => {
              if (workflows[selectedTaskIndex].dueDateTime) {
                const updatedWorkflows = workflows;
                updatedWorkflows[selectedTaskIndex].dueDateTimeEndOfDay = false;
                updatedWorkflows[selectedTaskIndex].dueDateTime = 0;
                setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
              } else {
                const updatedWorkflows = workflows;
                updatedWorkflows[selectedTaskIndex].dueDateTimeEndOfDay = true;
                updatedWorkflows[selectedTaskIndex].dueDateTime = 1; // needs to be greater than 0
                setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
              }
            }}
          >
            {dueDateTime
              ? 'Remove Tracking Completion Time'
              : 'Track Completion Time'}
          </Link>
        </Tooltip>
      </Box>
    ));
}

DueDateComponent.propTypes = {
  workflows: PropTypes.array,
  setWorkflows: PropTypes.func,
  selectedTaskIndex: PropTypes.number,
  entityIdentifier: PropTypes.any, // used to trigger when the resource changes and we need to reset form
};

DueDateComponent.defaultProps = {
  workflows: [PropTypes.array],
  setWorkflows: () => { },
  selectedTaskIndex: -1,
  entityIdentifier: '',
};

export default DueDateComponent;
